import { render, staticRenderFns } from "./UserRides.vue?vue&type=template&id=0977d879&scoped=true"
import script from "./UserRides.vue?vue&type=script&lang=js"
export * from "./UserRides.vue?vue&type=script&lang=js"
import style0 from "./UserRides.vue?vue&type=style&index=0&id=0977d879&prod&lang=css"
import style1 from "./UserRides.vue?vue&type=style&index=1&id=0977d879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0977d879",
  null
  
)

export default component.exports